module.exports = __webpack_public_path__ + "Wireframes12.png?059e108ebc0acca045d8719626de5818";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes12.png
// module id = 111
// module chunks = 0